import { useCallback, useMemo } from "react"
import { useAppDispatch, useAppSelector } from "../../store"
import { set_is_playing, set_loading, set_progress } from "./slice"
import { useAudioRef } from "@/components/context/audio"

export function useStoreAudio() {
  const dispatch = useAppDispatch()
  
  const isPlaying = useAppSelector(state => state.audio_slice.value.isPlaying)
  const progress = useAppSelector(state => state.audio_slice.value.progress)
  const isLoading = useAppSelector(state => state.audio_slice.isLoading)
  
  const ref = useAudioRef()

  const setIsLoading = useCallback((p: boolean) => {
    dispatch(set_loading(p))
  }, [dispatch])

  const setIsPlaying = useCallback((p: boolean) => {
    dispatch(set_is_playing(p))
  }, [dispatch])

  const setProgress = useCallback((p: number) => {
    dispatch(set_progress(p))
  }, [dispatch])

  return useMemo(() => ({
    isPlaying,
    isLoading,
    progress,
    ref,
    setIsPlaying,
    setProgress,
    setIsLoading
  }), [isPlaying, isLoading, progress, ref, setIsPlaying, setProgress, setIsLoading])
}